module.exports = __webpack_public_path__ + "img/AU.8a9ec0c1.webp";